import React, { useEffect, useState } from 'react';
import { BottomSheet, Button } from '@encarpkg/design';
import classNames from 'classnames/bind';
import * as api from 'app/api';
import useInquiry from 'app/hook/buyInquiry/useInquiry';
import { loggingException } from 'app/libs/sentry';
import useEnlog from 'app/hook/common/useEnlog';
import useCars from 'app/hook/cars/useCars';
import useDetailPage from 'app/hook/cars/useDetailPage';
import useLeadMarketing from 'app/hook/cars/useLeadMarketing';
import styles from './LayerSimpleInquiry.module.scss';

const cx = classNames.bind(styles);

const DIRECT_WRITE_ID = 'directInquiry';

function LayerSimpleInquiry({ onClose, onClick, carId }) {
	const { changeComm, inquiryItems } = useInquiry();
	const { onLeadMarketing } = useLeadMarketing();
	const { enloggingJsonData } = useEnlog();
	const { base } = useCars();
	const { viewMode } = useDetailPage();
	const isPc = viewMode === 'pcMode';

	useEffect(() => {
		const dataTalkViewSingle = {
			eventNameGroup: '간편문의',
		};
		enloggingJsonData({
			dataTalkViewSingle,
		});
	}, [enloggingJsonData]);

	const handleLinkWrite = () => {
		if (isPc) {
			window.open(`/buyinquiry/write/${carId}`, 'buy-inquiry', 'width=500,height=760,scrollbars=yes');
		} else {
			window.location.href = `/buyinquiry/write/${carId}`;
		}
	};

	const [selectedInquiry, setSelectedInquiry] = useState(null);
	const handelInquiryRequest = () => {
		if (!selectedInquiry) return;
		onLeadMarketing('normalChat');
		onClose(); // 열려있던 레이어 닫기
		if (selectedInquiry === DIRECT_WRITE_ID) {
			handleLinkWrite();
			return;
		}
		const categoryMap = ['msg_check', 'msg_price', 'msg_visit', 'msg_condition'];
		changeComm({ name: 'textInquiry', value: '' });
		changeComm({ name: 'selectInquiry', value: selectedInquiry });
		changeComm({ name: 'selectCategory', value: categoryMap[selectedInquiry - 1] });

		onClick();
	};
	const inquiryList = inquiryItems.map((item) => (
		<li key={item.id}>
			<div className={cx('inquiry_radio')}>
				<input
					type="radio"
					id={item.id}
					className={cx('btn_radio')}
					checked={selectedInquiry === item.id}
					onChange={() => setSelectedInquiry(item.id)}
					data-enlog-dt-eventname="간편문의"
					data-enlog-dt-eventnamegroup="간편문의"
					data-enlog-dt-param={JSON.stringify({
						attributes: `${item.id}`,
					})}
				/>
				<label
					htmlFor={item.id}
					className={cx('btn_label')}
				>
					{item.title}
				</label>
			</div>
		</li>
	));

	useEffect(() => {
		(async () => {
			try {
				const channel = isPc ? 'WWW_WEB' : 'MOBILE_WEB';
				const { data } = await api.getQuickInquiry(channel);
				changeComm({ name: 'inquiryItems', value: data });
			} catch (e) {
				loggingException(e);
				console.log(e);
			}
		})();
	}, [base.vehicleId, changeComm, isPc]);

	return (
		<BottomSheet
			isOpen
			hasCloseBtn
			onClose={onClose}
			header={
				<strong className={cx('tit_layer')}>
					어떤 점이 궁금하신가요?
					<br />
					혹시 이런 질문을 해 보시겠어요?
				</strong>
			}
			btnContent={
				<Button.V2
					domType="button"
					color="primary"
					size={50}
					disabled={!selectedInquiry}
					onClick={handelInquiryRequest}
					data-enlog-dt-eventnamegroup="간편문의"
					data-enlog-dt-param={JSON.stringify({
						attributes: selectedInquiry,
					})}
				>
					구매문의 보내기
				</Button.V2>
			}
		>
			<div className={cx('list_inquiry')}>
				<ul>
					{inquiryList}
					<li>
						<div className={cx('inquiry_radio')}>
							<input
								type="radio"
								id={DIRECT_WRITE_ID}
								className={cx('btn_radio')}
								checked={selectedInquiry === DIRECT_WRITE_ID}
								onChange={() => setSelectedInquiry(DIRECT_WRITE_ID)}
								data-enlog-dt-eventnamegroup="간편문의"
								data-enlog-dt-param={JSON.stringify({
									attributes: inquiryItems.length + 1,
								})}
							/>
							<label
								htmlFor={DIRECT_WRITE_ID}
								className={cx('btn_label')}
							>
								궁금한 내용 직접 문의하기
							</label>
						</div>
					</li>
				</ul>
			</div>
		</BottomSheet>
	);
}

export default LayerSimpleInquiry;
